<template>
    <v-container fluid>
        <h1>약관 동의</h1>
        <v-progress-linear
                v-if="!isInit"
                indeterminate
        ></v-progress-linear>
        <template v-if="isInit && notLinkedTerms.length > 0">
            <v-sheet color="rgba(0,0,0,0)" class="mb-4 mt-4 terms-container">
                <v-card v-for="term in notLinkedTerms"
                        class="term mt-0 mb-0 mb-md-6"
                        flat
                        :key="term.termsId"
                        color="rgba(0,0,0,0)"
                >
                    <v-checkbox
                        v-model="termsAgreements"
                        color="var(--primary-color, #1976d2)"
                        :value="term.termsId"
                        :label="term.requiredYn === 'Y'
                            ? '[필수] ' + term.termsName
                            : '[선택] ' + term.termsName"
                        hide-details="auto"
                        class="my-2 my-md-3"
                    >
                        <template v-slot:message="{ key, message }">
                            {{ key }} : {{ message }}
                        </template>
                        <template v-slot:append>
                            <v-btn small
                                   text
                                   color="var(--secondary-color, #2196F3)"
                                   :to="'/home/termViewer/' + term.termsId">
                                <v-icon small class="mr-1">mdi-fullscreen</v-icon>
                                전체
                            </v-btn>
                        </template>
                    </v-checkbox>
                    <v-card
                        v-if="!$vuetify.breakpoint.smAndDown"
                        ref="termContent"
                        style="overflow: auto; background-color: #fefefe;"
                        max-height="300"
                        outlined
                    >
                        <v-card-text flat
                             class="markdown-preview pa-4"
                             style="height: 100%; color:black"
                             v-html="previewContents[term.termsId]"
                        >
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-sheet>

            <v-divider v-if="notLinkedTerms.length > 1"></v-divider>

            <v-checkbox v-if="notLinkedTerms.length > 1"
                        color="var(--primary-color, #1976d2)"
                        label="전체 동의"
                        hint="필수 약관을 모두 동의해야 방문 신청이 가능합니다."
                        persistent-hint
                        @change="toggleAllTerms"
                        class="mb-6"
            >
            </v-checkbox>
        </template>

        <v-footer app
                  fixed
                  outlined
                  height="50"
                  color="#fff"
                  class="px-2 justify-center"
        >
            <v-row justify="end" align="center" no-gutters>
                <v-col>
                    <v-btn
                        v-for="term in linkedTerms"
                        small
                        :key="term.termsId"
                        text
                        color="#424242"
                        @click="viewTerm(term)"
                    >
                        {{ term.termsName }}
                    </v-btn>
                </v-col>
                <v-col cols="auto">
                    <v-btn
                        depressed
                        class="secondary-btn"
                        @click="gotoHome"
                    >
                        취소
                    </v-btn>
                    <v-btn
                        depressed
                        width="100"
                        :disabled="!valid"
                        class="ml-2 primary-btn"
                        @click="agreeTerms"
                    >
                        동의
                    </v-btn>
                </v-col>
            </v-row>
        </v-footer>
    </v-container>
</template>

<script>
import "@/assets/css/markdown.css";
import {marked} from "marked";
import TermsMixin from "@/pages/home/views/apply/TermsMixin";

marked.use({
    async: true,
    pedantic: false,
    gfm: true,
});

export default {
    name: 'AgreeTerms',
    mixins: [TermsMixin],
    data: () => ({
        isInit: false,
        marked: marked,
        previewContents: {},
    }),

    computed: {
        valid() {
            const requiredTermsIds = this.notLinkedTerms
                .filter(term => term.requiredYn === 'Y')
                .map(term => term.termsId);

            return requiredTermsIds.every(termsId => this.termsAgreements.includes(termsId));
        },

        notLinkedTerms() {
            return this.terms.filter(e => e.isLink === 'N');
        },

        linkedTerms() {
            return this.terms.filter(e => e.isLink === 'Y');
        }
    },

    async created() {
        this.$store.commit('setTermsAgreements', []);
    },

    async mounted() {
        await this.fetchTerms();
    },

    methods: {
        toggleAllTerms(checked) {
            if (checked) {
                this.termsAgreements = this.notLinkedTerms.map(e => e.termsId);
            } else {
                this.termsAgreements = [];
            }
        },

        async fetchTerms() {
            this.$window.showLoading("약관 로딩 중...");

            try {
                this.terms = await this.availableTerms();
                for (let index in this.terms) {
                    const term = this.terms[index];
                    marked
                        .parse(term.contents)
                        .then(renderingHtml => {
                            this.$set(this.previewContents, term.termsId, renderingHtml);
                        })
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.isInit = true;
                this.$window.hideLoading();
            }
        },

        agreeTerms() {
            this.$router.push('/home/applyReservation')
        },

        viewTerm(term) {
            this.$router.push(`/home/termViewer/${term.termsId}`)
        },

        gotoHome() {
            this.$router.push('/home');
        }
    },
}
</script>

<style>
.terms-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.term {
    flex: 1;
    display:flex;
    flex-direction: column;
    min-height: 50px;
    /* max-height: 320px; 이 값은 자동계산됨 */
}

.terms-container .term .markdown-preview {
    overflow: auto;
    flex-grow: 1;
}

.terms-container .term:only-child {
    max-height: calc(100vh - 300px);
}

.linked-terms .v-toolbar__content {
    justify-content: center !important;
}

.term .v-input--checkbox .v-messages {
    display:none;
}


</style>